

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _index = require('xo-models/src/address/index');

var _index2 = require('xo-models/src/checkout/index');

var _logger = require('xo-beaver/dist/logger');

require('xo-form-components/src/select-shipping-country/directive');

require('xo-tray-height/dist/directive');

require('../add-address/directive');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _statusconfig = require('./statusconfig');

var _statusconfig2 = _interopRequireDefault(_statusconfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var normalizationState = {
    error: 'error',
    normalizedAddressUnavailable: 'normalizedAddressUnavailable',
    requiredFieldsDontMatch: 'requiredFieldsDontMatch',
    normalizedAddressAvailable: 'normalizedAddressAvailable',
    fullMatch: 'fullMatch'
};

exports['default'] = _squid.$Component.extend('xoAddressNormalizationEdit', {
    tag: 'xo-address-normalization-edit',
    template: _template2['default'],

    lifecycle: {
        populate: function populate() {
            var _this = this;

            (0, _angular.$timeout)(function () {
                return _this.$element.find('#closeForm').focus();
            }, 1000);
        }
    },

    scope: {
        id: '=?',
        address: '=?',
        sidebar: '=?',
        strictAddressNormalization: '=?',
        backUri: '=?',
        doneFn: '=?'
    },

    controller: ['$scope', '$element', function ($scope, $element) {
        _squid.$util.assert($scope.address, 'Original Address cannot be empty');

        if (!(0, _squid.$feature)('addressNormalizationEdit', false, $scope.address.country)) {
            return $scope.doneFn();
        }
        var $el = $($element);
        var config = JSON.parse(_statusconfig2['default']);
        var strictMode = $scope.strictAddressNormalization;

        $scope.normalization = config.status.initial;
        $scope.disableChangeShippingCountry = true;
        $scope.userEditAddress = false;
        $scope.normalizedEditAddress = false;

        (0, _squid.$populate)($scope, {
            checkoutSession: _index2.$CheckoutSessionModel.instance($scope.id)
        }).then(function () {
            var normalizationValue = void 0;
            fpti('prepare_' + $scope.normalization.instrumentation.transitionTo, $scope.address);
            $scope.servAddress = copyAddress($scope.address, 'NORMALIZED', $scope.address);

            getAddressNormalizationStatus().then(function () {
                if (normalizationValue === normalizationState.error) {
                    throw new Error('ERROR_ON_ADDRESS_NORMALIZATION_SERVICE');
                } else if (normalizationValue === normalizationState.fullMatch) {
                    updateAddress($scope.servAddress);
                } else {
                    $scope.showNormalizationForm = true;
                    trinityResponseCallback(normalizationValue);
                }
            })['catch'](function (error) {
                errorHandler(name, error, 'getAddressNormalizationStatus', 'error');
                $scope.doneFn();
            });

            function getAddressNormalizationStatus() {
                $scope.addressNormalization = new _index.$AddressNormalizationModel({
                    id: $scope.id,
                    address: $scope.servAddress
                });

                return $scope.addressNormalization.save({
                    data: $scope.addressNormalization,

                    contingencies: {
                        VALIDATION_ERROR: function VALIDATION_ERROR() {
                            normalizationValue = normalizationState.normalizedAddressUnavailable;
                        }
                    },

                    success: function success(result) {
                        normalizationValue = normalizationState.fullMatch;
                        // If empty response from Trinity, stop the user to double check his address
                        if (!result) {
                            normalizationValue = normalizationState.normalizedAddressUnavailable;
                            return;
                        }
                        $scope.normalizedAddress = copyAddress(result, 'NORMALIZED', $scope.servAddress);
                        // If normalized and original adddress are equal, don't stop the user
                        if (addressesEqual($scope.normalizedAddress, $scope.servAddress)) {
                            normalizationValue = normalizationState.fullMatch;
                            return;
                        }
                        if (strictMode) {
                            normalizationValue = normalizationState.normalizedAddressAvailable;
                            return;
                        }
                        if (!strictMode && !requiredFieldsMatch(result, $scope.servAddress)) {
                            normalizationValue = normalizationState.requiredFieldsDontMatch;
                            return;
                        }
                    },

                    error: function error() {
                        normalizationValue = normalizationState.error;
                    }
                });
            }

            function setFormStatus(status) {
                switch (status) {
                    case normalizationState.normalizedAddressAvailable:
                        $scope.normalizedAddressEdit = copyAddress($scope.normalizedAddress);
                        $scope.normalization = config.status.normalizedAddressAvailable;
                        break;
                    case normalizationState.requiredFieldsDontMatch:
                        $scope.servAddressEdit = copyAddress($scope.normalizedAddress, 'UNNORMALIZED_USER_PREFERRED');
                        $scope.normalization = config.status.requiredFieldsDontMatch;
                        break;
                    default:
                        $scope.servAddressEdit = copyAddress($scope.servAddress, 'UNNORMALIZED_USER_PREFERRED');
                        $scope.normalization = config.status.normalizedAddressUnavailable;
                        break;
                }
            }

            function trinityResponseCallback(response) {
                setFormStatus(response);
                // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
                _angular.$rootScope.$applyAsync(function () {
                    centerLightBox();
                    $(window).resize(centerLightBox);
                });
            }

            function focusFirstError() {
                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            }

            function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = $($el.find('[ng-model="address.' + field.field + '"]'));

                            if ($field.length === 0 && field.field === 'zip') {
                                $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                            }
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                        }
                    });
                    focusFirstError();
                }
            }

            var errorHandler = function errorHandler(name, err, action, type) {
                _logger.$logger.error('address_normalization_edit', {
                    'int_error_code': err,
                    'int_error_description': action + '-' + type,
                    'error_source': 'paymentapiplatformserv'
                });
            };

            function updateAddress(address) {
                $scope.checkoutSession.shipping.action('update', {
                    data: address,
                    resultModel: $scope.checkoutSession,
                    success: function success(result) {
                        $scope.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['smallToolTip.onlyAddressUpdated']
                        };
                        fpti('process_' + $scope.normalization.instrumentation.transitionTo, address);
                        $scope.doneFn();
                    },
                    validation: function validation(res) {
                        handleValidation(res);
                    },
                    contingencies: function contingencies(name, err) {
                        errorHandler(name, err, 'updateAddress', 'contingency');
                        $scope.doneFn();
                    },

                    error: function error(name, err) {
                        errorHandler(name, err, 'updateAddress', 'error');
                        $scope.doneFn();
                    }
                });
            }

            $scope.saveAndContinue = function () {
                switch ($scope.normalization.addressSelected) {
                    case 'normalizedAddress':
                        if (addressesEqual($scope.normalizedAddress, $scope.normalizedAddressEdit)) {
                            $scope.servAddress = copyAddress($scope.normalizedAddress);
                        } else {
                            $scope.servAddress = copyAddress($scope.normalizedAddressEdit, 'UNNORMALIZED_USER_PREFERRED');
                        }
                        break;
                    case 'editedAddress':
                        if (normalizationValue === normalizationState.requiredFieldsDontMatch && addressesEqual($scope.servAddressEdit, $scope.normalizedAddress)) {
                            $scope.servAddress = copyAddress($scope.servAddressEdit, 'NORMALIZED');
                        } else {
                            $scope.servAddress = copyAddress($scope.servAddressEdit, 'UNNORMALIZED_USER_PREFERRED');
                        }

                        break;
                    default:
                        break;
                }
                updateAddress($scope.servAddress);
            };

            function getName(name, country) {
                // Lets use griffin to get Name from Full Name
                var index = name.trim().indexOf(' ');
                var firstName = name.substr(0, index);
                var lastName = name.substr(index + 1);

                var recipientName = firstName + ' ' + lastName;
                if ((0, _squid.$feature)('nameFormat', country, country) === 'LastFirst') {
                    recipientName = lastName + ' ' + firstName;
                }

                return {
                    recipient_name: recipientName,
                    first_name: firstName,
                    last_name: lastName
                };
            }

            // This function is based on US Address fields
            // To extend to other countries, excluding fields
            // that don't belong to address works better (i.e. id, name, etc)
            function copyAddress(address, normalizationStatus, sessionInfo) {
                var name = getName(address.recipient_name || sessionInfo.recipient_name || sessionInfo.name, address.country);

                var localAddress = {
                    id: address.id || sessionInfo.id,
                    recipient_name: name.recipient_name,
                    first_name: name.first_name,
                    last_name: name.last_name,
                    line1: address.line1,
                    line2: address.line2,
                    city: address.city,
                    state: address.state,
                    postal_code: address.postal_code,
                    country: address.country,
                    normalization_status: normalizationStatus || address.normalization_status,
                    preferred_address: sessionInfo ? sessionInfo.preferred_address : address.preferred_address,
                    default_address: sessionInfo ? sessionInfo.default_address || sessionInfo['default'] : address.default_address
                };

                return localAddress;
            }

            function getShortPostalCode(address) {
                var dashIndex = address.postal_code.indexOf('-');
                return dashIndex !== -1 ? address.postal_code.substr(0, dashIndex) : address.postal_code;
            }

            function requiredFieldsMatch(addressOne, addressTwo) {
                var requiredFields = (0, _squid.$feature)('normalizationRequiredFields');
                $scope.missMatch = {};
                var fieldsMissMatch = void 0;
                for (var field in requiredFields) {
                    if (field === 'postalCode') {
                        $scope.missMatch[field] = getShortPostalCode(addressOne) !== getShortPostalCode(addressTwo);
                    } else {
                        $scope.missMatch[field] = addressOne[field] !== addressTwo[field];
                    }
                    fieldsMissMatch |= $scope.missMatch[field];
                }
                return !fieldsMissMatch;
            }

            // make space and case insensitive. sub empty vals for undefined.
            function desensitizedAddress(addr) {
                for (var key in addr) {
                    var val = addr[key];
                    if (addr.hasOwnProperty(key)) {
                        if (val && val.length) {
                            addr[key] = val.trim().toLowerCase();
                        } else {
                            addr[key] = undefined;
                        }
                    }
                }
                return addr;
            }

            function addressesEqual(address1, address2) {
                var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
                var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));

                if (!addressOne || !addressTwo) {
                    return false;
                }

                return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
            }

            function fpti(toValue, address) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'addr_norm',
                    to: toValue,
                    shipping_address_id: address.id,
                    normalized: address.normalization_status
                });
            }

            $scope.selection = function (value) {
                $scope.normalization.addressSelected = value;
                $scope.normalization.instrumentation = config.instrumentation[value];
            };

            $scope.showUserEditAddress = function () {
                $scope.userEditAddress = !$scope.userEditAddress;
                $scope.normalizedEditAddress = false;
                $el.find('#addressOriginal').prop('checked', true);
                $scope.selection('enteredAddress');
            };

            $scope.showNormalizedEditAddress = function () {
                $scope.normalizedEditAddress = !$scope.normalizedEditAddress;
                $scope.userEditAddress = false;
                $el.find('#addressNormalized').prop('checked', true);
                $scope.selection('normalizedAddress');
            };

            function centerLightBox() {
                var element = $('#lbox');
                if (!element.length) {
                    return;
                }

                var windowElement = $(window);
                var lboxContainerElem = $('#lboxContainer');
                element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
                element.css('width', '65%');
                var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
                var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
                var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
                if (computedLeft < leftBound) {
                    element.css('width', lboxContainerElem.width() * 0.8);
                }
                element.css('left', Math.max(0, elementLeft) + 'px');
                return element;
            }

            // Australia displays address line2 first
            $scope.isLine2First = function () {
                return $scope.address.country === 'AU';
            };

            $scope.removeValidation = function () {
                $el.find('form').removeClass('validated');
            };
        });
    }]
});


_angular.$timeout;

_angular.$rootScope;

_squid.$Component;

_squid.$populate;

_squid.$feature;

_squid.$util;

_index.$AddressNormalizationModel;

_index2.$CheckoutSessionModel;

_logger.$logger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-address-components/src/address-normalization-edit/directive.js
// module id = ../node_modules/xo-address-components/src/address-normalization-edit/directive.js
// module chunks = 0